(() => {
  const formatMoney = (cents, format) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return String(format || '${{amount}}').replace('{{amount}}', amount).replace('{{ amount }}', amount);
  };

  if (window.coolflyFlex20PdpInstalled) return;
  window.coolflyFlex20PdpInstalled = true;
  const initialize = (root) => {
    if (root.dataset.flexInitialized) return;
    root.dataset.flexInitialized = 'true';
    const assigned = root.dataset.assigned === 'true';
    if (!assigned) document.body.classList.add('cf-flex-pdp-unassigned');
    const main = root.querySelector('[data-flex-main-media]');
    const price = root.querySelector('[data-flex-price]');
    const add = root.querySelector('[data-flex-add]');
    const addLabel = root.querySelector('[data-flex-add-label]');
    const variantInput = root.querySelector('[data-flex-variant-id]');
    const caption = root.querySelector('[data-flex-gallery-caption]');
    const setupMedia = root.querySelector('[data-flex-setup-media]');
    const setupSelection = root.querySelector('[data-flex-setup-selection]');
    const setupPrice = root.querySelector('[data-flex-setup-price]');
    const setupAdds = root.querySelectorAll('[data-flex-setup-add]');
    const productForm = root.querySelector('[data-type="add-to-cart-form"]');
    const kitImages = { one: root.dataset.colorOneKit, two: root.dataset.colorTwoKit };
    const sceneImages = { one: root.dataset.colorOneScene, two: root.dataset.colorTwoScene };

    const stopVideo = () => {
      main?.querySelectorAll('video').forEach((video) => video.pause());
    };

    const setMainImage = (url, alt, crop = false) => {
      if (!url || !main) return;
      stopVideo();
      main.innerHTML = crop
        ? `<div class="cf-flex-pdp__camera-crop"><img src="${url}" alt="${alt}"></div>`
        : `<img src="${url}" alt="${alt}">`;
    };

    const setSetupImage = (url, alt) => {
      if (!url || !setupMedia) return;
      setupMedia.innerHTML = `<img src="${url}" alt="${alt}">`;
    };

    root.querySelectorAll('[data-media-url]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-media-url]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', 'true');
        const videoTemplate = button.nextElementSibling;
        if (main && videoTemplate?.matches('template[data-flex-video]')) {
          stopVideo();
          main.replaceChildren(videoTemplate.content.cloneNode(true));
        } else {
          setMainImage(button.dataset.mediaUrl, button.getAttribute('aria-label'));
        }
      });
    });

    if (assigned) {
      const variantsNode = root.querySelector('[data-flex-variants]');
      const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
      const optionGroups = [...root.querySelectorAll('[data-option-position]')];
      const setupButtons = [...root.querySelectorAll('[data-setup-option-value]')];
      const positions = [...new Set(optionGroups.map((group) => group.dataset.optionPosition))];
      const selectedValue = (position) => optionGroups
        .find((group) => group.dataset.optionPosition === position)
        ?.querySelector('[data-option-value][aria-pressed="true"]')?.dataset.optionValue;
      const setPackageContent = (value) => {
        const isKit = value === 'Ready-to-Watch Kit';
        root.querySelectorAll('[data-flex-kit-only]').forEach((node) => { node.hidden = !isKit; });
        root.querySelectorAll('[data-flex-camera-only]').forEach((node) => { node.hidden = isKit; });
        if (caption) caption.textContent = isKit
          ? root.dataset.kitCaption
          : root.dataset.cameraCaption;
      };
      const updateVariant = () => {
        const choices = positions.map(selectedValue);
        const variant = variants.find((item) => item.options.every((value, index) => value === choices[index]));
        if (!variant) {
          add.disabled = true;
          setupAdds.forEach((button) => { button.disabled = true; });
          addLabel.textContent = root.dataset.unavailableLabel;
          variantInput.value = '';
          return;
        }
        variantInput.value = variant.id;
        price.textContent = formatMoney(variant.price, root.dataset.moneyFormat);
        add.disabled = !variant.available;
        addLabel.textContent = variant.available ? root.dataset.addLabel : root.dataset.soldoutLabel;
        setupAdds.forEach((button) => { button.disabled = !variant.available; });
        if (setupSelection) setupSelection.textContent = variant.title;
        if (setupPrice) setupPrice.textContent = `${formatMoney(variant.price, root.dataset.moneyFormat)} ${root.dataset.currency}`;
        setupButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.setupOptionValue === variant.options[0])));
        setPackageContent(variant.options[0]);
        if (variant.mediaUrl) {
          setMainImage(variant.mediaUrl, `Flex${root.dataset.model} ${variant.title}`);
          setSetupImage(variant.mediaUrl, `Flex${root.dataset.model} ${variant.title}`);
          root.querySelectorAll('[data-media-url]').forEach((button) => {
            const selected = button.dataset.mediaUrl === variant.mediaUrl;
            button.setAttribute('aria-pressed', String(selected));
            if (selected) {
              const thumbs = button.parentElement;
              const bounds = thumbs.getBoundingClientRect();
              const itemBounds = button.getBoundingClientRect();
              if (itemBounds.left < bounds.left) {
                thumbs.scrollBy({ left: itemBounds.left - bounds.left });
              } else if (itemBounds.right > bounds.right) {
                thumbs.scrollBy({ left: itemBounds.right - bounds.right });
              }
            }
          });
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };
      optionGroups.forEach((group) => {
        group.querySelectorAll('[data-option-value]').forEach((button) => button.addEventListener('click', () => {
          optionGroups
            .filter((item) => item.dataset.optionPosition === group.dataset.optionPosition)
            .forEach((matchingGroup) => {
              matchingGroup.querySelectorAll('[data-option-value]').forEach((item) => item.setAttribute('aria-pressed', String(item.dataset.optionValue === button.dataset.optionValue)));
              const label = matchingGroup.querySelector('[data-option-label]');
              if (label) label.textContent = button.dataset.optionValue;
            });
          updateVariant();
        }));
      });
      setupButtons.forEach((button) => button.addEventListener('click', () => {
        optionGroups
          .filter((group) => group.dataset.optionPosition === '1')
          .forEach((group) => {
            group.querySelectorAll('[data-option-value]').forEach((item) => item.setAttribute('aria-pressed', String(item.dataset.optionValue === button.dataset.setupOptionValue)));
            const label = group.querySelector('[data-option-label]');
            if (label) label.textContent = button.dataset.setupOptionValue;
          });
        updateVariant();
      }));
      if (productForm) setupAdds.forEach((button) => button.addEventListener('click', () => add.click()));
      updateVariant();
      return;
    }

    let style = 'kit';
    let color = 'one';
    const styleButtons = root.querySelectorAll('[data-demo-style]');
    const colorButtons = root.querySelectorAll('[data-demo-color]');
    const included = root.querySelector('[data-flex-included]');
    const colorLabel = root.querySelector('[data-flex-color-label]');
    const cameraPrice = Number(root.dataset.demoCameraPrice);
    const kitPrice = Number(root.dataset.demoKitPrice);
    const renderDemo = () => {
      styleButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.demoStyle === style)));
      colorButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.demoColor === color)));
      const label = color === 'one' ? root.dataset.colorOne : root.dataset.colorTwo;
      colorLabel.textContent = label;
      price.textContent = 'Price pending confirmation';
      included.textContent = style === 'kit' ? 'Includes camera, Gooseneck Mount and 2W Solar Panel.' : 'Camera only. Mount and solar panel sold separately.';
      caption.textContent = style === 'kit' ? 'Kit includes camera, Gooseneck Mount and 2W Solar Panel' : 'Camera Only · mount and solar panel sold separately';
      setMainImage(kitImages[color], `Flex${root.dataset.model} ${label}`, style === 'camera');
      const isKit = style === 'kit';
      root.querySelectorAll('[data-flex-kit-only]').forEach((node) => { node.hidden = !isKit; });
      root.querySelectorAll('[data-flex-camera-only]').forEach((node) => { node.hidden = isKit; });
      root.querySelectorAll('[data-setup-option-value]').forEach((button) => button.setAttribute('aria-pressed', String((button.dataset.setupOptionValue === 'Ready-to-Watch Kit') === isKit)));
      if (setupMedia) setupMedia.innerHTML = isKit ? `<img src="${kitImages[color]}" alt="Flex20 Ready-to-Watch Kit / ${label}">` : `<div class="cf-flex-pdp__camera-crop"><img src="${kitImages[color]}" alt="Flex20 camera / ${label}"></div>`;
      if (setupSelection) setupSelection.textContent = `${isKit ? 'Ready-to-Watch Kit' : 'Camera Only'} / ${label}`;
      if (setupPrice) setupPrice.textContent = 'Price pending confirmation';
      setupAdds.forEach((button) => { button.disabled = true; });
    };
    styleButtons.forEach((button) => button.addEventListener('click', () => { style = button.dataset.demoStyle; renderDemo(); }));
    colorButtons.forEach((button) => button.addEventListener('click', () => { color = button.dataset.demoColor; renderDemo(); }));
    root.querySelectorAll('[data-demo-media]').forEach((button) => button.addEventListener('click', () => {
      root.querySelectorAll('[data-demo-media]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
      button.setAttribute('aria-pressed', 'true');
      const label = color === 'one' ? root.dataset.colorOne : root.dataset.colorTwo;
      if (button.dataset.demoMedia === 'scene') setMainImage(sceneImages[color], `Flex${root.dataset.model} ${label} placement`);
      else setMainImage(kitImages[color], `Flex${root.dataset.model} ${label}`, style === 'camera');
    }));
    root.querySelectorAll('[data-setup-option-value]').forEach((button) => button.addEventListener('click', () => { style = button.dataset.setupOptionValue === 'Ready-to-Watch Kit' ? 'kit' : 'camera'; renderDemo(); }));
    renderDemo();
  };
  const initializeWithin = (scope) => {
    scope.querySelectorAll('.cf-flex-pdp--flex20-draft[data-section-id]').forEach(initialize);
  };
  initializeWithin(document);
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
